import RouteManagerBase from 'commonWeb/Routes/RouteManagerBase'
import {CurrentLang} from "common"

// routes config
import {baseRoutes, patientRoutes, treatmentRoutes, adminUserRoutes, adminClinicRoutes, adminOrganisationRoutes, patientRoutesBase, treatmentRoutesBase, adminRoutesBase, contactRoute, currentOrganisationRoute, adminPhysicianRoutes, adminInsuranceProviderRoutes, importRoute, aboutRoute} from 'routes';

//const ROLE_USER_MANAGEMENT = "0083d185-f142-4fb8-8cf6-2b3e02ec051c"; // obsolete
//const ROLE_SYSTEM_UPDATER = "06c641c0-6d64-48ec-9348-442a80368884"; // not needed in PDM

const ROLE_MANAGE_USERS_MAGSTIM_ADMIN = "e70d4927-1b0b-41ce-a157-33777f7d935d"; // Create/Edit Magstim Admin
const ROLE_MANAGE_USERS_ORGANISATION_ADMIN = "0cbf95bf-aa16-4de2-be78-710a0f915d88"; // Create/Edit Organisation Admin
const ROLE_MANAGE_USERS_ORGANISATION_USER = "7044fa65-d162-40b2-b2e0-4433e0b9cd18"; // Create/Edit Organisations users

const ROLE_MANAGE_CLINICS = "a3f3c2d8-bd49-423b-ab25-e89802f51c32"; // Create/Edit Clinics

const ROLE_MANAGE_ORGANISATIONS = "157c6ad7-71b1-4228-8815-4cd71baf4c12"; // Create/Edit Organisations

const ROLE_MANAGE_TREATMENT_TEMPLATE = "f6e9fdcd-2c4e-4cec-b7d8-faff0c72d8b5"; // Create/Edit Treatment Templates
//const ROLE_RUN_TREATMENTS = "ec801301-6f6a-4cfc-8279-952d31f10baa"; // Run Treatments not needed in PDM

class _RouteManager extends RouteManagerBase {

    getAllRoutes(){
        var allRoutes = baseRoutes;
        allRoutes = allRoutes.concat(patientRoutes);
        allRoutes = allRoutes.concat(treatmentRoutes);
        allRoutes = allRoutes.concat(adminUserRoutes);
        allRoutes = allRoutes.concat(adminClinicRoutes);
        allRoutes = allRoutes.concat(adminOrganisationRoutes);
        allRoutes = allRoutes.concat(currentOrganisationRoute);
        allRoutes = allRoutes.concat(adminPhysicianRoutes);
        allRoutes = allRoutes.concat(adminInsuranceProviderRoutes);
        allRoutes = allRoutes.concat(importRoute);
        return allRoutes;
    }

    setRoutes(systemUserRoles){      

        this.navigationItems = {items: [] };

        // Save org admin
        this.isOrganisationAdmin = systemUserRoles.includes(ROLE_MANAGE_USERS_ORGANISATION_USER)
        
        // Add the treatment navigation 
        if(systemUserRoles.includes(ROLE_MANAGE_TREATMENT_TEMPLATE)){
            
            // Patient Search
            this.navigationItems.items.push( 
                {
                    name: CurrentLang().route_patient_search,
                    url: `${patientRoutesBase}`,
                    icon: 'fa fa-search'
                });

            // Treatment plans
            this.navigationItems.items.push( 
                {    
                    name: CurrentLang().route_treatments_plans,
                    url:  `${treatmentRoutesBase}/BuildTreatmentPlan`,
                    icon: 'fas fa-file-prescription'
                });
        }

        if(this.hasAdminRoles(systemUserRoles)){
           
            // Build up the admin children
            var adminChildren = [];

            // All of these roles will have access to users - the access level will be provided by the API
            if(systemUserRoles.includes(ROLE_MANAGE_USERS_MAGSTIM_ADMIN) ||
               systemUserRoles.includes(ROLE_MANAGE_USERS_ORGANISATION_ADMIN) ||
               systemUserRoles.includes(ROLE_MANAGE_USERS_ORGANISATION_USER)){
                adminChildren.push(
                    {
                        name: CurrentLang().users,
                        url: `${adminRoutesBase}/Users`,
                        icon: 'fa fa-user'
                    }
                );
            }

            if(systemUserRoles.includes(ROLE_MANAGE_CLINICS)){
                adminChildren.push(
                    {
                        name: CurrentLang().clinics,
                        url: `${adminRoutesBase}/Clinics`,
                        icon: 'fas fa-clinic-medical'
                    }
                );
            }

            if(systemUserRoles.includes(ROLE_MANAGE_ORGANISATIONS)){
                adminChildren.push(
                    {
                        name: CurrentLang().organisations,
                        url: `${adminRoutesBase}/Organisations`,
                        icon: 'fa fa-building'
                    }   
                );
            }else{
                adminChildren.push(
                    {
                        name: CurrentLang().organisation,
                        url: `${adminRoutesBase}/Organisation`,
                        icon: 'fa fa-building'
                    }   
                );

                adminChildren.push(
                    {
                        name: CurrentLang().physicians,
                        url: `${adminRoutesBase}/Physicians`,
                        icon: 'fas fa-user-nurse'
                    }   
                );

                adminChildren.push(
                    {
                        name: CurrentLang().insurance_providers,
                        url: `${adminRoutesBase}/InsuranceProviders`,
                        icon: 'fas fa-user-shield'
                    }   
                );
            }

            // Magstim users cant import
            if(systemUserRoles.includes(ROLE_MANAGE_USERS_MAGSTIM_ADMIN) === false){
                adminChildren.push(
                    {
                        name: CurrentLang().import_export,
                        url: `${adminRoutesBase}/Import`,
                        icon: 'fas fa-upload'
                    }   
                );
            }

            this.navigationItems.items.push( 
            {
                name: CurrentLang().route_admin,
                url: '#',
                icon: 'fa fa-users',
                children:adminChildren,
            });
        }

        // All users have the contact page
        this.navigationItems.items.push( 
        {
            name: CurrentLang().route_contact,
            url: `${contactRoute}`,
            icon: 'fa fa-phone'
        });
          
        // All users have the about page
        this.navigationItems.items.push( 
            {
                name: CurrentLang().about,
                url: `${aboutRoute}`,
                icon: 'fa fa-industry'
        });

        // Only enable a route if it's in the navigation items
        this.routesForCurrentUser = baseRoutes;
        this.navigationItems.items.forEach((n, i) => {
            if(n.children){
                n.children.forEach((n, i) => {    
                   this.routesForCurrentUser = this.addRoutes(n.url, this.routesForCurrentUser);          
                });
            }else{
                this.routesForCurrentUser = this.addRoutes(n.url, this.routesForCurrentUser);
            }
        });

        //console.log(this.routesForCurrentUser);
    }

    addRoutes(url, routes){
        switch (url) {
            case `${patientRoutesBase}`:
                routes = routes.concat(patientRoutes);
            break;
            case `${treatmentRoutesBase}/BuildTreatmentPlan`:
                routes = routes.concat(treatmentRoutes);
            break;
            case `${adminRoutesBase}/Users`:
                routes = routes.concat(adminUserRoutes);
            break;
            case `${adminRoutesBase}/Clinics`:
                routes = routes.concat(adminClinicRoutes);
            break;
            case `${adminRoutesBase}/Organisations`:
                routes = routes.concat(adminOrganisationRoutes);
            break;
            case `${adminRoutesBase}/Organisation`:
                routes = routes.concat(currentOrganisationRoute);
            break;
            case `${adminRoutesBase}/Physicians`:
                routes = routes.concat(adminPhysicianRoutes);
            break;
            case `${adminRoutesBase}/InsuranceProviders`:
                routes = routes.concat(adminInsuranceProviderRoutes);
            break;
            case `${adminRoutesBase}/Import`:
                routes = routes.concat(importRoute);
            break;
            default:
            break;
        }

        if(this.baseRoute.length === 0){
            this.baseRoute = url;
        }

        return routes;
    }
   

}

const routeManager = new _RouteManager();

export default routeManager;